<style lang="scss" scoped>
    @media screen and (max-width: 767px) {
        .table_quotation > .table > {
            thead,
            tbody,
            tfoot {
                > tr > {
                    th:first-child, 
                    td:first-child {
                        white-space: pre-line;
                    }
                }
            }
        }
    }
</style>

<template>
    <div class="table-responsive table_quotation">
        <table class="table m-0 table-hover">
            <thead>
            <tr>
                <th style="min-width: 180px;">{{ $t('description') }}</th>
                <th class="t_center w_60" style="min-width: 60px;">{{ $t('amount') }}</th>
                <th class="t_right w_150" style="min-width: 150px;">{{ $t('total') }}</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in products">
                    <td>
                        {{ item.product.name }}
                        <small class="show" v-if="item.show_details">({{ item.supplier.fancy_name }})</small>
                        <small class="show" v-if="item.description" v-html="format(item.description)"></small>
                    </td>
                    <td class="t_center">{{ item.amount }} {{ $t(item.unit) }}</td>
                    <td class="t_right">
                        <span v-if="item.unit_price > 0">
                            {{ item.amount * item.unit_price * record.exchange_rate | pmlCurrency(currency.symbol) }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="t_right bold t_uppercase">{{ $t('subtotal') }}</td>
                    <td class="t_right bold">
                        {{ record.total_products * record.exchange_rate | pmlCurrency(currency.symbol) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'Products',
        props: [ 'record', 'products', 'currency' ],
        methods: {
            format (val) {
                return this.$options.filters.pmlNl2br(val) || ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Products.vue